import BaseDecorator from "./BaseDecorator";

export default class ReviewDecorator extends BaseDecorator {
  static AGE_GROUPS = ["18-24", "25-30", "31-40", "41-60", "60+"];
  static GROUP_TYPES = ["single", "couple", "friends", "family"];

  static get age_group_options() {
    return this.AGE_GROUPS.map((age_group) => [age_group, I18n.humanAttributeName("review", age_group)]);
  }

  static get group_type_options() {
    return this.GROUP_TYPES.map((group_type) => [group_type, I18n.humanAttributeName("review", group_type)]);
  }

  get age_group_i18n() {
    return this.age_group && I18n.humanAttributeName("review", this.age_group);
  }

  get group_type_i18n() {
    return this.group_type && I18n.humanAttributeName("review", this.group_type);
  }
}



// WEBPACK FOOTER //
// ./src/lib/decorators/ReviewDecorator.js